// import './App.css'
import AppRouter from "@/router/appRouter";
import { AppContext, isMobile } from "@/context";
import { useState} from "react";
import useScreenSize from "@/hooks/useScreenSize";
import {Toaster} from "@/components/ui/toaster";



function App() {
    const [screen] = useState<isMobile>({
        isMobile: useScreenSize().width <= 900,
    });

    return (
        <>
            <AppContext.Provider value={screen}>
                <AppRouter />
                <Toaster />
            </AppContext.Provider>
        </>
    );
}

export default App
